import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import _ from 'lodash';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import Card from '../ui/card';
import AreaTotalChangeCard from './areaTotalChange-card';
import AreaAnalyticsCard from './areaAnalytics-card';
import TerminalParkingcountTrendChart from './terminalParkingCountTrend-chart';
import HeatMap from './heatMap';
var t = i18n.getFixedT(null, 'traffic-statistic');
var Statistic = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      _useSelector$trafficS = _useSelector.trafficStatistic,
      areaTrendChartData = _useSelector$trafficS.areaTrendChartData,
      terminalTrendChartData = _useSelector$trafficS.terminalTrendChartData,
      roadSectionChartData = _useSelector$trafficS.roadSectionChartData,
      fetchAreaDataStatus = _useSelector$trafficS.fetchAreaDataStatus,
      fetchTerminalDataStatus = _useSelector$trafficS.fetchTerminalDataStatus;

  var dispatch = useDispatch(); // const renderWaittingComponent = (data, dom) => {
  //     if(_.isEmpty(data)) {
  //         return (<div className='loading'>
  //             <i className='fa fa-circle-notch fa-spin fa-3x fa-fw' />
  //         </div>)
  //     }
  //     return dom
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: "traffic-statistic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "chart-card-info"
  }, /*#__PURE__*/React.createElement(Card, {
    title: t('lbl-inout-area-total-trend'),
    enableFullScreen: true
  }, /*#__PURE__*/React.createElement(AreaTotalChangeCard, {
    areaTrendChartData: areaTrendChartData
  })), /*#__PURE__*/React.createElement(Card, {
    title: t('lbl-terminal-parking-count-tend'),
    enableFullScreen: true
  }, /*#__PURE__*/React.createElement(TerminalParkingcountTrendChart, {
    terminalTrendChartData: terminalTrendChartData
  }))), /*#__PURE__*/React.createElement(AreaAnalyticsCard, {
    roadSectionChartData: roadSectionChartData
  }), /*#__PURE__*/React.createElement(HeatMap, null));
});
export default Statistic;